import { loginUserAction } from 'pages/cliente/_redux/actions';
import { accessTokenClienteSelector } from 'pages/cliente/_redux/selectors';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const LoginCliente: React.FC = () => {

  const query = useQuery();

  const dispatch = useAppDispatch();
  const accessTokenCliente = useAppSelector(accessTokenClienteSelector);
  const history = useHistory();

  useEffect(() => {
    // supponiamo di avere in querystring il parametro userToken, che consentirà all'operatore banca di effettuare l'autenticazione
    const tokenEmail = query.get('tokenEmail');
    if (tokenEmail) {
      // provo a fare login user
      localStorage.removeItem('accessTokenCliente');
      dispatch(loginUserAction(tokenEmail));
    } else {
      history.push(`/error-page`);
    }
  }, [dispatch, history, query]);


  useEffect(() => {
    if (accessTokenCliente) {
      localStorage.setItem('accessTokenCliente', accessTokenCliente);
      // localStorage.removeItem('accessTokenAdmin');
      history.replace(`/cliente`);
    }
  }, [history, accessTokenCliente]);

  return null;

}

export default LoginCliente;



